(function () {
  var style = document.createElement('style');
  style.textContent =
    '[data-gsap-section] [data-gsap="fade-up"],' +
    '[data-gsap-section] [data-gsap="fade-left"],' +
    '[data-gsap-section] [data-gsap="fade-right"],' +
    '[data-gsap-section] [data-gsap="fade-down"],' +
    '[data-gsap-section] [data-gsap="item"],' +
    '[data-gsap-section] [data-gsap="image"] { visibility: hidden; }';
  document.head.appendChild(style);
})();

gsap.registerPlugin(ScrollTrigger);

function animateBatch(elements, vars, start = "top 85%", stagger = 0.12) {
  if (!elements.length) return;
  elements.forEach(el => el.style.visibility = "");
  ScrollTrigger.batch(elements, {
    start,
    once: true,
    onEnter: (batch) => {
      batch.forEach(el => el.style.visibility = "visible");
      gsap.from(batch, { ...vars, stagger });
    }
  });
}

// New helper: reorders comparison-table cells into row-major order
// (row 1 across all 3 columns, then row 2, etc.) before animating.
function getTableCellsInRowOrder(section) {
  const table = section.querySelector('.cx-table');
  if (!table) return [];
  const cols = table.querySelectorAll('.cx-table__col');
  const perColCells = Array.from(cols).map(col =>
    Array.from(col.querySelectorAll('.cx-cell[data-gsap="fade-left"]'))
  );
  const rowCount = Math.max(...perColCells.map(c => c.length), 0);
  const ordered = [];
  for (let r = 0; r < rowCount; r++) {
    perColCells.forEach(colCells => {
      if (colCells[r]) ordered.push(colCells[r]);
    });
  }
  return ordered;
}

// ── Fade direction config ──
const FADE_DIRECTIONS = {
  up:    { y: 60,  opacity: 0 },
  down:  { y: -60, opacity: 0 },
  left:  { x: 60,  opacity: 0 },
  right: { x: -60, opacity: 0 },
};

function initGSAPSections(container = document) {
  container.querySelectorAll("[data-gsap-section]").forEach((section) => {
    try {
      if (section._gsapContext) {
        section._gsapContext.revert();
      }

      const ctx = gsap.context(() => {
        const sectionType = section.dataset.sectionType;

        Object.entries(FADE_DIRECTIONS).forEach(([dir, offset]) => {
          const els = section.querySelectorAll(`[data-gsap="fade-${dir}"]`);
          animateBatch(els, { ...offset, duration: 1, ease: "power3.out" }, "top 70%");
        });

        const items  = section.querySelectorAll('[data-gsap="item"]');
        const images = section.querySelectorAll('[data-gsap="image"]');
        const itemStagger = sectionType === "comparison-experts" ? 0.15 : 0.12;

        animateBatch(items, { y: 60, opacity: 0, duration: 0.9, ease: "power3.out" }, "top 70%", itemStagger);
        animateBatch(images, { y: 50, opacity: 0, duration: 1, ease: "power3.out" }, "top 60%");

      }, section);

      section._gsapContext = ctx;
    } catch (err) {
      // Don't let one broken section block reveal of the rest of the page
      console.error('[gsap] section init failed, force-revealing:', section, err);
      section.querySelectorAll('[data-gsap]').forEach(el => {
        el.style.visibility = 'visible';
      });
    }
  });
}

// ── Refresh ScrollTrigger once layout has actually settled ──
// Waits for every currently-lazy/loading image on the page to finish
// (decoded, real dimensions known), then refreshes trigger positions.
// This is what a single setTimeout can't reliably guarantee.
function refreshAfterImagesSettle() {
  const imgs = Array.from(document.images).filter(img => !img.complete);
  if (imgs.length === 0) {
    ScrollTrigger.refresh();
    return;
  }
  const promises = imgs.map(img => new Promise(resolve => {
    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', resolve, { once: true });
  }));
  Promise.all(promises).then(() => {
    // small extra tick so browser finishes layout/paint after the last image
    requestAnimationFrame(() => requestAnimationFrame(() => ScrollTrigger.refresh()));
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initGSAPSections();
  setTimeout(() => ScrollTrigger.refresh(), 800);
});

window.addEventListener("load", () => {
  ScrollTrigger.refresh();
  refreshAfterImagesSettle();
});

// Also refresh whenever a lazy image scrolls into view and loads later
// (native loading="lazy" images can resolve well after window 'load').
// document.addEventListener('scroll', () => {
//   refreshAfterImagesSettle();
// }, { passive: true, once: false });

let scrollRefreshTimer;
document.addEventListener('scroll', () => {
  clearTimeout(scrollRefreshTimer);
  scrollRefreshTimer = setTimeout(refreshAfterImagesSettle, 150);
}, { passive: true });

// Debounced resize refresh (font swaps, viewport changes, etc.)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
});

document.addEventListener("shopify:section:load", (event) => {
  initGSAPSections(event.target);
  ScrollTrigger.refresh();
  refreshAfterImagesSettle();
});

document.addEventListener("shopify:section:unload", (event) => {
  const section = event.target;
  if (section._gsapContext) {
    section._gsapContext.revert();
    section._gsapContext = null;
  }
});